var classStatuses = [
    {"name": "آماده ثبت نام", id: 0},
    {"name": "ظرفیت تکمیل شد", id: 1},
    {"name": "خاتمه کلاس", id: 2},
];

export default classStatuses;